import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { login, signUp } from '../../Services/Auth'
import { vendor } from "../../Constant/index";
import Swal from "sweetalert2";



const Login = (props) => {

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loginShow, setLoginShow] = useState(false);
  const [user, setUser] = useState({
    email: '',
    password: ''
  })

  const [resgisterUser, setRegisterUser] = useState({
    name: '',
    email: '',
    password: ''
  })

  const handleLoginClose = () => props.setLoginShow(false);
  const handleLoginShow = () => setLoginShow(true);

  const [loginWeb, setChangeLogin] = useState(true);
  const loginHandler = () => {
    setErrors({})
    setChangeLogin(true);
  };
  const signHandler = () => {
    setErrors({})
    setChangeLogin(false);
  };


  const handleSignIn = async (e) => {
    e.preventDefault()
    let validate = validateForm(user)
    if (!validate) return
    setIsLoading(true)
    let payload = {
      email: user.email,
      password: user.password,
      vendor: vendor
    }
    const response = await login(payload);
    if(response.status == 200){
      setIsLoading(false)
      localStorage.setItem('ownezzy-user-token' , response.data.token)
      localStorage.setItem('ownezzy-user-name' , response.data.name)
      localStorage.setItem('ownezzy-user-email' , response.data.email)
      localStorage.setItem('ownezzy-user-id' , response.data._id)
      localStorage.setItem('ownezzy-user-loggedIn' , true)
      props.setLoginShow(false)
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Login Success!",
        showConfirmButton: false,
        timer: 1500
      });

    }else{
      setIsLoading(false)
      setLoginError(response.data.message)
    }
  };

  const handleloginChange = (e) => {
    // return
    setLoginError('')
    let { name, value } = e.target
    setUser({
      ...user,
      [name]: value
    })
    setErrors({
      ...errors,
      [name]: ''
    })
  };


  const handleSignUpChange = (e) => {
    // return
    setLoginError('')
    let { name, value } = e.target
    setRegisterUser({
      ...resgisterUser,
      [name]: value
    })
    setErrors({
      ...errors,
      [name]: ''
    })
  };

  let validateForm = (data) => {
    let errors = {};
    let formIsValid = true;

    if (data.email == '') {
      formIsValid = false;
      errors["email"] = `Email is required`;
    }
    if (data.password == '') {
      formIsValid = false;
      errors["password"] = `Password is required`;
    }
    
    setErrors(errors);
    return formIsValid
  }

  let validateSignUp = (data) => {
    let errors = {};
    let formIsValid = true;

    if (data.name == '') {
      formIsValid = false;
      errors["name"] = `Name is required`;
    }
    if (data.email == '') {
      formIsValid = false;
      errors["email"] = `Email is required`;
    }
    if (data.password == '') {
      formIsValid = false;
      errors["password"] = `Password is required`;
    }
    
    setErrors(errors);
    return formIsValid
  }

  let handleSignUp = async (e) =>{
    e.preventDefault()
    let validate = validateSignUp(resgisterUser)
    if (!validate) return

    setIsLoading(true)
    let payload = {
      name : resgisterUser.name,
      email: resgisterUser.email,
      password: resgisterUser.password,
      vendor: vendor
    }
    const response = await signUp(payload);
    if(response.status == 200){
      setIsLoading(false)
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Registraion successfull , You can login now!",
        showConfirmButton: false,
        timer: 1500
      });
      
      setChangeLogin(true);

    }else{
      setIsLoading(false)
      setLoginError(response.data.message)
    }

  }


  return (
    <>
      <Modal centered show={props.loginShow} onHide={handleLoginClose}>
        {
          isLoading ? <Modal.Header /> : <Modal.Header closeButton />
        }

        <Modal.Body className="p-5">
          {loginWeb ?
            <div className="login-wapper">
              <h3 className="login-heading">Login</h3>
              <div className="form-webbody">
                <div className="form-group mb-3">
                  <label className="txt-label-login">Email *</label>
                  <input onChange={handleloginChange} name='email' type="text" className="form-control input-web-txt" value={user.email} placeholder="Email" />
                  {errors.email ? <p className="error-msg">Email is required</p> : null}

                </div>
                <div className="form-group mb-3">
                  <label className="txt-label-login">Password *</label>
                  <input onChange={handleloginChange} name='password' type="password" className="form-control input-web-txt" value={user.password} placeholder="Password" />
                  {errors.password ? <p className="error-msg">Password is required</p> : null}
                </div>
                {
                  isLoading ?
                    <div className="form-group text-center mb-3">
                      <button class="btn btn-login-btn">Loading...</button>
                    </div> :
                    <div onClick={handleSignIn} className="form-group text-center mb-3">
                      <button class="btn btn-login-btn">Login</button>
                      {loginError ? <p style = {{fontSize: '13px'}} className="error-msg">{loginError}</p> : null}
                    </div>
                }
                <div className="form-group text-center">
                  <p className="mb-0 ftr-txtlogn">Not a member? <button type="button" class="txt-loginwgt" onClick={signHandler}>Sign up now</button></p>
                </div>
              </div>
            </div>
            :
            <div className="login-wapper">
              <h3 className="login-heading">Sign Up</h3>
              <div className="form-webbody">
                <div className="form-group mb-3">
                  <label className="txt-label-login">Name</label>
                  <input type="text" onChange={handleSignUpChange} className="form-control input-web-txt" name = 'name' value={resgisterUser.name} placeholder="Name" />
                  {errors.name ? <p className="error-msg">Name is required</p> : null}

                </div>
                <div className="form-group mb-3">
                  <label className="txt-label-login">Email</label>
                  <input type="text" onChange={handleSignUpChange}  className="form-control input-web-txt" name = 'email' value={resgisterUser.email} placeholder="Email" />
                  {errors.email ? <p className="error-msg">Email is required</p> : null}

                </div>
                <div className="form-group mb-3">
                  <label className="txt-label-login">Password</label>
                  <input type="password" onChange={handleSignUpChange}  className="form-control input-web-txt" name = 'password' value={resgisterUser.password} placeholder="Password" />
                  {errors.password ? <p className="error-msg">Password is required</p> : null}

                </div>
                <div className="form-group text-center mb-3">
                  <button type="submit" onClick={handleSignUp} class="btn btn-login-btn">Sign Up</button>
                  {loginError ? <p style = {{fontSize: '13px'}} className="error-msg">{loginError}</p> : null}

                </div>
                <div className="form-group text-center">
                  <p className="mb-0 ftr-txtlogn">Already a user? <button class="txt-loginwgt" onClick={loginHandler}>Login</button></p>
                </div>
              </div>
            </div>
          }
        </Modal.Body>

      </Modal>
    </>
  )
}
export default Login;